'use strict'

import DateUtil from '../../../lib/dateutil.jsx'

var React = require('react')
var createClass = require('create-react-class')
var moment = require('moment')
var onClickOutside = require('react-onclickoutside').default

var DateTimePickerDays = onClickOutside(
  createClass({
    render: function () {
      var footer = this.renderFooter()
      var date = this.props.viewDate
      var locale = date.localeData()
      var tableChildren
      var showWeekNo = this.props.showWeekNo
      tableChildren = [
        React.createElement('thead', { key: 'th' }, [
          React.createElement('tr', { key: 'h' }, [
            React.createElement(
              'th',
              {
                key: 'p',
                className: 'rdtPrev',
                onClick: this.props.subtractTime(1, 'months')
              },
              React.createElement('span', {}, '‹')
            ),
            React.createElement(
              'th',
              {
                key: 's',
                className: 'rdtSwitch',
                onClick: this.props.showView('months'),
                colSpan: showWeekNo ? 6 : 5,
                'data-value': this.props.viewDate.month()
              },
              locale.months(date) + ' ' + date.year()
            ),
            React.createElement(
              'th',
              {
                key: 'n',
                className: 'rdtNext',
                onClick: this.props.addTime(1, 'months')
              },
              React.createElement('span', {}, '›')
            )
          ]),
          React.createElement(
            'tr',
            { key: 'd' },
            this.getDaysOfWeek(locale).map(function (day, index) {
              return React.createElement(
                'th',
                { key: day + index, className: 'dow' },
                day
              )
            })
          )
        ]),
        React.createElement('tbody', { key: 'tb' }, this.renderDays())
      ]

      if (footer) tableChildren.push(footer)

      return React.createElement(
        'div',
        { className: `rdtDays${showWeekNo ? ' rdtDays-showweek' : ''}` },
        React.createElement('table', {}, tableChildren)
      )
    },

    /**
     * Get a list of the days of the week
     * depending on the current locale
     * @return {array} A list with the shortname of the days
     */
    getDaysOfWeek: function (locale) {
      var days = locale._weekdaysMin
      var first = 1
      var dow = []
      var i = 0
      days.forEach(function (day) {
        dow[(7 + i++ - first) % 7] = day
      })

      if (this.props.showWeekNo) {
        dow.unshift('#')
      }

      return dow
    },

    renderDays: function () {
      var date = this.props.viewDate
      var selected = this.props.selectedDate && this.props.selectedDate.clone()
      var prevMonth = date.clone().subtract(1, 'months')
      var currentYear = date.year()
      var currentMonth = date.month()
      var weeks = []
      var days = []
      var renderer = this.props.renderDay || this.renderDay
      var rendererWeek = this.props.renderWeek || this.renderWeek
      var isValid = this.props.isValidDate || this.alwaysValidDate
      var classes
      var isDisabled
      var dayProps
      var currentDate
      var showWeekNo = this.props.showWeekNo
      // Go to the last week of the previous month
      prevMonth.date(prevMonth.daysInMonth()).startOf('week')

      // If sunday, start from monday
      if (prevMonth._d.getDay() === 0 || prevMonth._d.getDay() === 7) {
        prevMonth.add(1, 'd')
      }

      var lastDay = prevMonth.clone().add(42, 'd')

      while (prevMonth.isBefore(lastDay)) {
        classes = 'rdtDay'
        currentDate = prevMonth.clone()

        if (
          (prevMonth.year() === currentYear &&
            prevMonth.month() < currentMonth) ||
          prevMonth.year() < currentYear
        ) {
          classes += ' rdtOld'
        } else if (
          (prevMonth.year() === currentYear &&
            prevMonth.month() > currentMonth) ||
          prevMonth.year() > currentYear
        ) {
          classes += ' rdtNew'
        }

        if (selected && prevMonth.isSame(selected, 'day')) {
          classes += ' rdtActive'
        }

        if (prevMonth.isSame(moment(), 'day')) classes += ' rdtToday'

        isDisabled = !isValid(currentDate, selected)
        if (isDisabled) classes += ' rdtDisabled'

        dayProps = {
          key: prevMonth.format('M_D'),
          'data-value': prevMonth.date(),
          className: classes
        }

        if (!isDisabled) dayProps.onClick = this.updateSelectedDate

        days.push(renderer(dayProps, currentDate, selected))

        if (days.length === 7) {
          if (showWeekNo) {
            const weekNo = DateUtil.getLocalWeekNo(
              prevMonth.clone().subtract(6, 'd')._d
            )
            days.unshift(
              rendererWeek(
                { key: `week${weekNo}`, className: 'rdtWeekNo' },
                weekNo
              )
            )
          }

          weeks.push(
            React.createElement('tr', { key: prevMonth.format('M_D') }, days)
          )
          days = []
        }

        prevMonth.add(1, 'd')
      }

      return weeks
    },

    updateSelectedDate: function (event) {
      this.props.updateSelectedDate(event, true)
    },

    renderDay: function (props, currentDate) {
      return React.createElement('td', props, currentDate.date())
    },

    renderWeek: function (props, weekNo) {
      return React.createElement('td', props, weekNo)
    },

    renderFooter: function () {
      if (!this.props.timeFormat) return ''

      var date = this.props.selectedDate || this.props.viewDate

      return React.createElement(
        'tfoot',
        { key: 'tf' },
        React.createElement(
          'tr',
          {},
          React.createElement(
            'td',
            {
              onClick: this.props.showView('time'),
              colSpan: 7,
              className: 'rdtTimeToggle'
            },
            date.format(this.props.timeFormat)
          )
        )
      )
    },

    alwaysValidDate: function () {
      return 1
    },

    handleClickOutside: function () {
      this.props.handleClickOutside()
    }
  })
)

export default DateTimePickerDays
